<template>
	<v-container fill-height fluid>
		<v-row align="center" justify="center">
			<v-col cols="11" sm="9" md="6" lg="5">
				<h1 class="display-1 font-weight-black font-italic primary--text my-8">Забули пароль?</h1>
				<p>Введи email свого акаунта. Ми надішлемо посилання для встановлення нового пароля.</p>
				<v-alert v-if="message" type="success" text role="status">{{ message }}</v-alert>
				<v-alert v-if="error" type="error" text role="alert">{{ error }}</v-alert>
				<v-form ref="form" @submit.prevent="submit">
					<v-text-field
						v-model="email"
						label="Email"
						name="email"
						type="email"
						autocomplete="email"
						:rules="emailRules"
						:disabled="loading"
						maxlength="255"
						required />
					<v-btn type="submit" color="btnBg" class="btnTxt--text my-4" :loading="loading" :disabled="loading || cooldown > 0">
						{{ cooldown > 0 ? `Повторити через ${cooldown} с` : 'Надіслати посилання' }}
					</v-btn>
				</v-form>
				<p class="mt-4"><router-link :to="{ name: 'login' }">Повернутися до входу</router-link></p>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import authApi from '../../api/authApi'

export default {
	data() {
		return {
			email: typeof this.$route.query.email === 'string' ? this.$route.query.email : '',
			loading: false,
			message: '',
			error: '',
			cooldown: 0,
			timer: null,
			emailRules: [value => !!value.trim() || 'Вкажи email', value => /\S+@\S+\.\S+/.test(value) || 'Перевір email'],
		}
	},
	beforeDestroy() {
		clearInterval(this.timer)
	},
	methods: {
		startCooldown(seconds) {
			clearInterval(this.timer)
			this.cooldown = seconds
			this.timer = setInterval(() => {
				this.cooldown = Math.max(0, this.cooldown - 1)
				if (!this.cooldown) clearInterval(this.timer)
			}, 1000)
		},
		async submit() {
			if (this.loading || this.cooldown || !this.$refs.form.validate()) return
			this.loading = true
			this.error = ''
			this.message = ''
			try {
				const { data } = await authApi.sendResetLinkEmail({ email: this.email.trim() })
				this.message = data.message
				this.startCooldown(60)
			} catch (error) {
				const response = error.response || {}
				if (response.status === 429) {
					this.startCooldown(Number(response.headers && response.headers['retry-after']) || 60)
					this.error = 'Лист уже запитано. Зачекай трохи перед повторною спробою.'
				} else {
					this.error = response.status === 422 ? 'Перевір введений email.' : 'Не вдалося надіслати лист. Перевір з’єднання та спробуй ще раз.'
				}
			} finally {
				this.loading = false
			}
		},
	},
}
</script>
